import {
  Component,
  ComponentFactory,
  ComponentFactoryResolver,
  ComponentRef, ElementRef,
  EventEmitter, Injectable, Injector,
  Input, OnChanges,
  OnDestroy,
  OnInit,
  Output, ReflectiveInjector,
  Renderer2, ResolvedReflectiveProvider, ViewContainerRef
} from '@angular/core';
import {RulesService} from '../../rules.service';
import {Constants} from '../../constants';
import {Subscription} from 'rxjs/Subscription';
import {SetConditionComponent} from '../set-condition/set-condition.component';
import {Positioning} from 'positioning';
import {SearchDropdownComponent} from '../../../shared/search-dropdown/search-dropdown.component';
import {SetConditionOption} from '../../model/Set-condition.option.service';

@Component({
  selector: 'app-condition-col',
  templateUrl: './condition-col.component.html',
  styleUrls: ['./condition-col.component.scss']
})
export class ConditionColComponent implements OnInit, OnDestroy, OnChanges {
  title: string = Constants.THING_SEARCHBOX_TITLE;
  thingList;
  selectedItem;
  subscription: Subscription;
  url: string = Constants.URL;
  propertyName: string = Constants.NAME;
  setConditionPopover: ComponentRef<SetConditionComponent>;
  searchDropDown: ComponentRef<SearchDropdownComponent>;
  sub: Subscription;
  isLoading: boolean;
  @Input() index;
  @Input() rowIndex;
  @Input() columnData;
  @Output() cancelEdit: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(private ruleService: RulesService,
              private renderer: Renderer2,
              private cfr: ComponentFactoryResolver,
              private viewContainerRef: ViewContainerRef,
              private elm: ElementRef) { }

  ngOnInit() {
   this.getThingList();
   this.listenToEditColumn();
  }

  ngOnChanges() {
  }
  get position() {
    return this.rowIndex > 0 ? Constants.TOP : Constants.BOTTOM;
  }

  get selectListItems() {
    return this.ruleService.getParentThing() && this.ruleService.hasMoreThanOneCondition() ?
      [this.ruleService.getParentThing()] : this.thingList;
  }
  private getThingList() {
    this.isLoading = true;
    this.subscription = this.ruleService.getThingListSubject()
      .subscribe(res => {
        this.thingList = res;
        if (this.columnData.isNew && !this.columnData.isEditMode) {
          this.isLoading = false;
        }
      });
  }
  ngOnDestroy() {
   this.subscription.unsubscribe();
   this.sub.unsubscribe();
   this.removePopover();
  }

  listenToEditColumn() {
    this.sub = this.ruleService.getEditColumnSubscription()
      .subscribe(item => this.removePopover());
  }
  onItemSelect(item) {
    this.ruleService.notifyEditColumn();
    this.selectedItem = item;
    this.columnData.isEditMode = true;
    this.columnData.condition.attributeParent = item.id;
    this.showConditionPopOver();
  }
  onSaveCondition($event) {
    this.columnData.condition = $event;

    this.ruleService.saveCondition(this.columnData, this.index, this.rowIndex);
    this.removePopover();
  }
  onCancelEdit($event) {
    this.columnData.isEditMode = false;
    this.removePopover();
  }
  onEditModeOpen($event) {
    this.ruleService.notifyEditColumn();
    this.selectedItem = this.ruleService.getThing(this.columnData.condition.attributeParent);
    this.ruleService.resetAllEditMode();
    this.columnData.isEditMode = true;
    this.showConditionPopOver();
  }
  onDeleteColumn() {
    this.ruleService.deleteColumn(this.rowIndex, this.index);
  }

  private showConditionPopOver() {
    let options = {
      condition: null,
      selectedItem: null,
      index: null,
      onSave: (event): void => {
        this.onSaveCondition(event);
      },
      onCancel: (event): void => {
        this.onCancelEdit(event);
      }
    };
    if (this.columnData.condition) {
      options.condition = this.columnData.condition;
    }
    if (this.selectedItem) {
      options.selectedItem = this.selectedItem;
    }
    if (!isNaN(this.index)) {
      options.index = this.index;
    }
    const componentFactory: ComponentFactory<SetConditionComponent> =
      this.cfr.resolveComponentFactory(SetConditionComponent);
    const binding: ResolvedReflectiveProvider[] = ReflectiveInjector.resolve([{
      provide: SetConditionOption,
      useValue: options
    }]);
    const contextInjector: Injector = this.viewContainerRef.parentInjector;
    const childInjector: Injector = ReflectiveInjector.fromResolvedProviders(binding, contextInjector);
    this.setConditionPopover = this.viewContainerRef.createComponent(
      componentFactory,
      this.viewContainerRef.length,
      childInjector
    );
    document.body.appendChild(this.setConditionPopover.location.nativeElement);
    this.positionPopover(this.setConditionPopover);
  }

  private showDropDown() {
    let options = {
       hasLabel: false,
       url: this.url,
       title: this.title,
       propertyName: this.propertyName,
       isAsync: true,
       isOpen : false,
       isAbsolute: true,
       data: this.selectListItems,
       onSelect: (event) => {
        this.onItemSelect(event);
      },
    };
    const componentFactory: ComponentFactory<SearchDropdownComponent> =
      this.cfr.resolveComponentFactory(SearchDropdownComponent);
    const binding: ResolvedReflectiveProvider[] = ReflectiveInjector.resolve([{
      provide: DropDownOption,
      useValue: options
    }]);
    const contextInjector: Injector = this.viewContainerRef.parentInjector;
    const childInjector: Injector = ReflectiveInjector.fromResolvedProviders(binding, contextInjector);
    this.searchDropDown = this.viewContainerRef.createComponent(
      componentFactory,
      this.viewContainerRef.length,
      childInjector
    );
    if (this.index === 0) {
      document.body.appendChild(this.searchDropDown.location.nativeElement);
      this.positionSearchDropDown();
    } else {
      let element = this.searchDropDown.location.nativeElement.children[0];
      this.elm.nativeElement.appendChild(this.searchDropDown.location.nativeElement);
      this.renderer.setStyle(element, 'top', '-10px');
      this.renderer.setStyle(
        element,
        'left',
        '-1px'
      );
    }
  }
  private removePopover(): void {
    if (this.setConditionPopover) {
      this.setConditionPopover.destroy();
      delete this.setConditionPopover;
    }
  }
  private removeDropDown(): void {
    if (this.searchDropDown) {
      this.searchDropDown.destroy();
      delete this.searchDropDown;
    }
  }
  private positionPopover(popover): void {
    if (popover) {
      const popoverElement = popover.location.nativeElement.children[0];
      let popoverPosition = this.elm.nativeElement.getBoundingClientRect();
      const topOffset = this.elm.nativeElement.parentNode.parentNode.offsetHeight;
      let top = this.getTop(topOffset, popoverPosition.top, popoverElement);
      this.renderer.setStyle(popoverElement, 'top', `${top}px`);
      let left = screen.width - (popoverPosition.left + popoverElement.offsetWidth)  <= 0 ?
        screen.width - popoverElement.offsetWidth - 40 :  popoverPosition.left ;
      this.renderer.setStyle(
        popoverElement,
        'left',
        `${left - 10}px`
      );
    }
  }
  private positionSearchDropDown(): void {
    if (this.searchDropDown) {
      const popoverElement = this.searchDropDown.location.nativeElement.children[0];
      let popoverPosition = this.elm.nativeElement.getBoundingClientRect();
      this.renderer.setStyle(popoverElement, 'top', `${popoverPosition.top }px`);
      this.renderer.setStyle(
        popoverElement,
        'left',
        `${popoverPosition.left - 9}px`
      );
    }
  }

  private getTop(offset, top, element): number {
    let elementHeight = element.offsetHeight;
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return this.position === Constants.TOP ? top + scrollTop - elementHeight : top + scrollTop - 30;
  }




}



@Injectable()
export  class DropDownOption {
  onSelect: (item) => {};
  propertyName: any;
  hasLabel: any;
  title: any;
  data: any;
  isAsync: boolean;
  url: string;
  isOpen: boolean;
  isAbsolute: boolean;
}



// WEBPACK FOOTER //
// ./src/app/rules/new-rule/condition-col/condition-col.component.ts